import React from "react";
import { Table } from "antd";

const columns = [
  {
    title: "First Floor Pay and park Parking",
    dataIndex: "name",
  },
];
const data = [
  {
    key: "1",
    name: "Mumbai central railway station west station parking…",
  },
  {
    key: "2",
    name: "Pillar no 31 C, P7-East, Multi level car parking, T2- in",
  },
];

const searchedLocations = () => {
  return (
    <div className="searched-locations">
      <div>
        <Table columns={columns} dataSource={data} 
        size="small" />
      </div>
    </div>
  );
};

export default searchedLocations;
